import type { IconProps } from "types";

const Checkmark = ({ width = "15", height = "15", color = "currentColor", onClick, style }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" style={style} onClick={onClick}>
    <path fill={color} d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
  </svg>
);

export default Checkmark;